<template>
    <div class="modal fade" :id="id" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content modal-content-scv-FRONTENDEX-MOBILE-APP">
                <div class="modal-body modal-body-scv-FRONTENDEX-MOBILE-APP">
                    <span v-html="confirmMessage"></span>
                </div>
                <div class="d-flex justify-content-start flex-column flex-fill">
                    <div class="scv-separator-line-list-FRONTENDEX-MOBILE-APP"></div>
                    <button class="scv-btn-color-modal-FRONTENDEX-MOBILE-APP scv-btn-design-FRONTENDEX-MOBILE-APP-square-FRONTENDEX-MOBILE-APP-confirm" type="button" @click="onBtn1(id)">{{btn1}}</button>
                    <div class="scv-separator-line-list-FRONTENDEX-MOBILE-APP"></div>
                    <button class="scv-btn-color-modal-FRONTENDEX-MOBILE-APP scv-btn-design-FRONTENDEX-MOBILE-APP-square-FRONTENDEX-MOBILE-APP-confirm" type="button" @click="onBtnCancel(id)">キャンセル</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
    import { Options, Vue } from 'vue-class-component';
    import { BootstrapUtil } from 'lib-vue-v2/util';

    @Options({
        components: {
        },
        props: {
            id: String,
            confirmMessage: String,
            btn1: String
        },
        emits: [
            'onBtn1',
            'onCancel'
        ]
    })

    /**
     * 確認ダイアログコンポーネント
     */
    export default class ConfirmDialog extends Vue {

        /**
         * ボタン1
         */
        public onBtn1(id: string): void {
            BootstrapUtil.hideModal(id);
            this.$emit('onBtn1');
        }

        /**
         * 「キャンセル」ボタン
         */
        public onBtnCancel(id: string): void {
            BootstrapUtil.hideModal(id);
            this.$emit('onCancel');
        }
    }
</script>
<style scoped>
    .scv-btn-design-FRONTENDEX-MOBILE-APP-square-FRONTENDEX-MOBILE-APP-confirm {
        border-radius: 14px;
        border: none;
        height: 44px;
    }
</style>
